import React, { useContext } from 'react';
import clsx from 'clsx';
import Icon from 'component/icon';
import { TableContext } from './context';

const DraggableIcon = (props) => {
    const { row } = props;
    const {
        rowKey, setSelectedRow,
        onSelectRowRef,
        draggingRow, setDraggingRow,
        draggingOffset
    } = useContext(TableContext);

    return (
        <div
            className={clsx(
                'w-6 h-6 flex justify-center items-center rounded-md cursor-grab',
                'text-gray-dark02 bg-gray-light01 dark:bg-gray-dark02',
                'hover:bg-table-row-selected hover:dark:bg-table-row-selected',
                'hover:text-table-tab-selected hover:dark:text-table-tab-selected',
                {
                    'bg-table-row-selected dark:bg-table-row-selected':
                        draggingRow && draggingRow === row[rowKey]
                },
                {
                    'text-table-tab-selected dark:text-table-tab-selected':
                        draggingRow && draggingRow === row[rowKey]
                }
            )}
            onMouseDown={(e) => {
                setDraggingRow(row[rowKey]);
                setSelectedRow(row[rowKey]);
                onSelectRowRef.current?.(row[rowKey]);
                const { top } = e.target.parentElement.getBoundingClientRect();
                draggingOffset.current = e.clientY - top;
            }}
        >
            <Icon name="more_vert" />
        </div>
    );
};

export default DraggableIcon;
